import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { inject as service } from "@ember/service"
import hasMany from "../../../helpers/has-many-collectively"

@tagName("")
export default class PlanbookCoursesProvider extends Component {
  @service("ember-store") store

  @hasMany("planbook", "course", "courses") courses
}
